angular.module('satv.track')
    .factory('Keyword', ['config', '$resource', function (config, $resource) {
        return $resource(config.apiUri + '/keywords/:keywordId', {
            keywordId: '@keywordId'
        });
    }])
    .factory('KeywordsLoader', ['$q', 'Keyword', function ($q, Keyword) {
        return function (params) {
            var delay = $q.defer();
            Keyword.query(params, function (result) {
                delay.resolve(result);
            }, function () {
                delay.reject('Unable to fetch keywords');
            });
            return delay.promise;
        };
    }])
;


// WEBPACK FOOTER //
// ./vendor/sonyatv/smfcoreclientbundle/Resources/js/angular/services/Keyword.js